/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function UserFocus(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M224,48V76a8,8,0,0,1-16,0V48H180a8,8,0,0,1,0-16h28A16.01833,16.01833,0,0,1,224,48Zm-8,124a8.00008,8.00008,0,0,0-8,8v28H180a8,8,0,0,0,0,16h28a16.01833,16.01833,0,0,0,16-16V180A8.00008,8.00008,0,0,0,216,172ZM76,208H48V180a8,8,0,0,0-16,0v28a16.01833,16.01833,0,0,0,16,16H76a8,8,0,0,0,0-16ZM40,84a8.00008,8.00008,0,0,0,8-8V48H76a8,8,0,0,0,0-16H48A16.01833,16.01833,0,0,0,32,48V76A8.00008,8.00008,0,0,0,40,84Zm61.06079,57.54077a67.94605,67.94605,0,0,0-33.21313,30.72095A7.99956,7.99956,0,0,0,74.92041,184H181.07959a7.99956,7.99956,0,0,0,7.07275-11.73828,67.94605,67.94605,0,0,0-33.21313-30.72095,40,40,0,1,0-53.87842,0Z" />
    </Svg>
  );
}

export default UserFocus;
